export class CreateInviteParams {
  uuid: string
  expiresAt: string | null

  constructor({ uuid, expiresAt }: { uuid: string, expiresAt: string | null }) {
    this.uuid = uuid
    this.expiresAt = expiresAt
  }
}
